import { AbstractControl, UntypedFormGroup, UntypedFormArray } from '@angular/forms'

/**
 * EventConvertHook Class usage under development - Keeping it for future reference
 */
export abstract class PersonaValueChangeHook {
  /** Method to be executed when value changes */
  abstract valueChanged(personas: UntypedFormArray, persona: UntypedFormGroup, control: AbstractControl, value): void
}
/** Array of PersonaValueChangeHook */
export declare type PersonaValueChangeHooks = PersonaValueChangeHook[]

/**
 * Persona property value change gooks
 * each key is a persona value change hook
 */
export interface PersonaPropertyValueChangeHooks {
  [key: string]: PersonaValueChangeHooks
}
